/*
 * Copyright, AlpineReplay, Inc. 2021. All rights reserved.
 * Author: Brian Bal
 */
import { webApi } from "../../lib/WebApi"
import { multisportify } from "trux"

let defaultValue = {
    loading: false,
    complete: false,
    error: null,
    value: null,
}

const loadDivisions = () => {
    return (dispatch, getState) => {
        let user = null
        if (getState().user.value) {
            user = getState().user.value
        }

        let divState = getState().divisions
        if (divState.loading || divState.complete) {
            // console.log("Loader.loadDivisions skip divisions update already loaded")
            return { type: "NOOP" }
            // eslint-disable-next-line eqeqeq
        } else if (user == null) {
            // console.log("load.loadDivisions skip divisions update no user")
            return { type: "NOOP" }
        }

        dispatch({
            type: "COMMON_SET",
            key: "divisions",
            value: { loading: true, error: null },
            defaultValue: { ...defaultValue },
        })

        // get divisions
        webApi
            ._get("/webapp/users/self/divisions", { sport_type: "any" })
            .then((divisions) => {
                return divisions.map((d) => {
                    d.teams = []
                    d.myTeams = []
                    return d
                })
            })
            // sort divisions
            .then((divisions) => {
                return divisions.sort((a, b) => {
                    return a.title.localeCompare(b.title)
                })
            })
            // get teams for each division
            .then((divisions) => {
                var requests = []
                for (var i in divisions) {
                    var div = divisions[i]
                    requests.push({
                        uri: `/divisions/${div.division_id}/teams`,
                        params: {
                            sport_type: "any",
                        },
                        method: "GET",
                    })
                }

                var params = {
                    requests: JSON.stringify(requests),
                }

                return webApi._post("/webapp/batch", params).then((json) => {
                    for (var i in divisions) {
                        divisions[i].teams = json[i].data
                        divisions[i].myTeams = []
                        if (
                            divisions[i].is_owner === true ||
                            divisions[i].is_owner === 1 ||
                            divisions[i].is_owner === "1"
                        ) {
                            divisions[i].myTeams = json[i].data
                        }
                    }
                    divisions.push({
                        is_owner: false,
                        division_id: -1,
                        title: "Other",
                        teams: [],
                        myTeams: [],
                    })
                    return divisions
                })
            })
            // get my teams
            .then((divisions) => {
                return webApi
                    ._get("/webapp/users/self/teams", { sport_type: "any" })
                    .then((teams) => {
                        for (var team of teams) {
                            var matched = false
                            for (var div of divisions) {
                                if (
                                    team.division_ids.includes(div.division_id)
                                ) {
                                    let ft = div.myTeams.find(
                                        (t) => t.team_id === team.team_id
                                    ) // eslint-disable-line no-loop-func
                                    if (!ft) {
                                        div.myTeams.push(team)
                                    }
                                    matched = true
                                }
                            }
                            if (!matched) {
                                divisions[divisions.length - 1].myTeams.push(
                                    team
                                )
                            }
                        }
                        // console.log("divisions", divisions)
                        return divisions
                    })
            })
            // get relations / relations teams
            .then((divisions) => {
                if (user) {
                    // console.log("loadTeams2 user logged in getting relations")
                    let relationsParams = {
                        relation_type: "parent",
                    }
                    return webApi
                        ._get(
                            `/webapp/users/${user.user_id}/relations`,
                            relationsParams
                        )
                        .then((relationsObj) => {
                            let requests = []
                            let relations = []
                            let relationsKeys = Object.keys(relationsObj)
                            for (var rk of relationsKeys) {
                                let rel = relationsObj[rk]
                                relations.push(rel)
                                requests.push({
                                    uri: `/users/${rel.related_user.user_id}/teams`,
                                    method: "GET",
                                })
                            }

                            dispatch({
                                type: "COMMON_SET",
                                key: "user",
                                value: {
                                    loading: false,
                                    complete: true,
                                    error: null,
                                    value: { ...user, relations: relations },
                                },
                                defaultValue: { ...defaultValue },
                            })

                            var params = {
                                requests: JSON.stringify(requests),
                            }

                            if (relations.length === 0) {
                                return divisions
                            }

                            return webApi
                                ._post("/webapp/batch", params)
                                .then((json) => {
                                    // console.log("loadTeams2", "relations", "teams", json)
                                    for (var i in relations) {
                                        let rel = relations[i]
                                        if (json[i].success) {
                                            divisions.push({
                                                is_owner: false,
                                                division_id: -1,
                                                title: `${rel.related_user.first_name}'s Teams`,
                                                teams: json[i].data,
                                                myTeams: json[i].data,
                                            })
                                        }
                                    }
                                    return divisions
                                })
                        })
                } else {
                    // console.log("loadTeams2 user not logged in skipping relations")
                    return divisions
                }
            })
            // sort & filter teams
            .then((divisions) => {
                // console.log("loadTeams2 sort", divisions)
                for (let div of divisions) {
                    div.myTeams.sort((a, b) => {
                        return a.title.localeCompare(b.title)
                    })
                }
                for (let div of divisions) {
                    if (div.division_id <= 0) {
                        // remove duplicates from other and relation's teams
                        div.myTeams = div.myTeams.filter((tm) => {
                            let keep = true
                            for (let d of divisions) {
                                if (d.division_id > 0) {
                                    for (let t of d.myTeams) {
                                        if (t.team_id === tm.team_id) {
                                            keep = false
                                            break
                                        }
                                    }
                                }
                            }
                            return keep
                        })
                    }
                }
                return divisions
            })
            // dispatch results
            .then((divisionsOrig) => {
                const divisions = multisportify(divisionsOrig)
                dispatch({
                    type: "COMMON_SET",
                    key: "divisions",
                    value: {
                        loading: false,
                        complete: true,
                        error: null,
                        value: divisions,
                    },
                    defaultValue: { ...defaultValue },
                })
                /*
				let divisionId = "0"
				for (let div of divisions) {
					if (div.division_id && div.division_id > 0) {
						divisionId = div.division_id
						break
					}
				}
				if (divisionId > 0) {
					console.log("ChurnZero", divisionId, user.email)
					window.ChurnZero.push(['setContact', divisionId, user.email]);
				} else {
					console.log("ChurnZero not loaded")
				}
				*/
            })
            .catch((err) => {
                dispatch({
                    type: "COMMON_SET",
                    key: "divisions",
                    value: {
                        loading: false,
                        complete: true,
                        error: err,
                        value: null,
                    },
                    defaultValue: { ...defaultValue },
                })
            })
    }
}

export default loadDivisions
